import { render, staticRenderFns } from "./chhosewechat.vue?vue&type=template&id=2a0df549&scoped=true"
import script from "./chhosewechat.vue?vue&type=script&lang=js"
export * from "./chhosewechat.vue?vue&type=script&lang=js"
import style0 from "./chhosewechat.vue?vue&type=style&index=0&id=2a0df549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0df549",
  null
  
)

export default component.exports